/** MapGL loader scoped to the dev Agent; it never reads the canvas map key. */
import type * as MapGL from '@2gis/mapgl/types';

const LOAD_TIMEOUT_MS = 12_000;
let sdkPromise: Promise<typeof MapGL | null> | null = null;

export function agentMapglKey(): string {
  return import.meta.env.VITE_PP_DGIS_MAPGL_KEY ?? '';
}

/** Load the Agent's separately keyed MapGL SDK at most once per page. */
export function loadAgentMapgl(): Promise<typeof MapGL | null> {
  if (sdkPromise) return sdkPromise;
  if (!agentMapglKey().trim()) {
    sdkPromise = Promise.resolve(null);
    return sdkPromise;
  }

  const loading = (async () => {
    const loader = await import('@2gis/mapgl');
    const sdk = await loader.load();
    return sdk.isSupported() ? sdk : null;
  })();

  sdkPromise = new Promise<typeof MapGL | null>((resolve) => {
    const timer = setTimeout(() => resolve(null), LOAD_TIMEOUT_MS);
    loading.then(
      (sdk) => {
        clearTimeout(timer);
        resolve(sdk);
      },
      () => {
        clearTimeout(timer);
        resolve(null);
      },
    );
  });
  return sdkPromise;
}

/** Tests only: each test gets a fresh memoized loader. */
export function resetAgentMapglForTests(): void {
  sdkPromise = null;
}
